import { useLazyLoadQuery } from "react-relay"
import { type FetchPolicy, graphql } from "relay-runtime"
import {
  useCareProviderQuickListQuery,
  useCareProviderQuickListQuery$data,
  useCareProviderQuickListQuery$variables,
} from "@/modules/care-provider/simple-search/services/__generated__/useCareProviderQuickListQuery.graphql"

export type ApplicableInsuranceCareProviderListIds = NonNullable<
  useCareProviderQuickListQuery$data["ch_careProviderQuickList"]["insurerNetwork"]
>["applicableInsuranceCareProviderListIds"]

export const careProviderQuickListQuery = graphql`
  query useCareProviderQuickListQuery(
    $patientId: ID!
    $language: String!
    $searchType: CareProviderSearchType!
    $specialtyId: ID
    $address: AddressInput
    $showInsurerNetwork: Boolean!
  ) {
    ch_careProviderQuickList(
      input: { patientId: $patientId, searchType: $searchType, specialtyId: $specialtyId, address: $address }
    ) {
      personalCareProviders {
        ...CareProviderSearchResultFragment @relay(mask: false)
      }
      insurerNetwork @include(if: $showInsurerNetwork) {
        careProviders {
          ...CareProviderSearchResultFragment @relay(mask: false)
        }
        applicableInsuranceCareProviderListIds
      }
      preselectedCareProviderId @include(if: $showInsurerNetwork)
    }
  }
`

export const useChCareProvidersLazyQuery = (
  careProviderQuickListQueryVariables: useCareProviderQuickListQuery$variables,
  fetchPolicy: FetchPolicy = "network-only",
) =>
  useLazyLoadQuery<useCareProviderQuickListQuery>(careProviderQuickListQuery, careProviderQuickListQueryVariables, {
    fetchPolicy,
  })
